import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { MenuItemHolder } from 'src/app/holders/menu-item-holder';
import { Detail } from 'src/app/models/detail';
import { DetailGroupPack } from 'src/app/models/detail-group-pack';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { ItemMenuService } from 'src/app/services/item-menu.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { StepperDialogComponent } from '../dialogs/stepper-dialog/stepper-dialog.component';
import { subscribe as KeyboardDetector } from 'on-screen-keyboard-detector';
import { ComboItemGroupModel } from 'src/app/models/combo';

@Component({
  selector: 'app-combo-item',
  templateUrl: './combo-item.component.html',
  styleUrls: ['./combo-item.component.scss']
})
export class ComboItemComponent implements OnInit 
{
  @ViewChild('bottomBar', { read: MatRipple })
  ripple?: MatRipple;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  itemGroup!:ComboItemGroupModel;
  itemHolder:MenuItemHolder = new MenuItemHolder();
  currentPriceString:string = '';
  canSave:boolean = false;
  canPop:boolean = false;
  rippleColor:string = "#FFFFFF25";
  
  initialAdditionalPrice:number = 0;

  status:string='edit';

  jumpedGroups:Array<string> = Array<string>();
  lastRippleDone:boolean = false;

  showBottomBar = true;

  constructor(
    private initializationservice:InitializationService, 
    private route: ActivatedRoute, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService,
    public alertDialog: MatDialog,
    private itemmenuservice:ItemMenuService,
    private localeservice:LocaleService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    var comboitemuid = String(this.route.snapshot.paramMap.get('comboitemuid'))
    this.status = String(this.route.snapshot.queryParamMap.get('status'));

    if(this.status === 'edit')
      this.itemHolder = this.currentorderservice.getComboItem(comboitemuid);

    if(this.status === 'new' || this.status === 'change')
      this.itemHolder = this.itemmenuservice.getMenuItemHolder(comboitemuid)

    this.initialAdditionalPrice = this.itemHolder.CurrentComboPrice * this.currentorderservice.getCurrentComboCount();

    var itemGroupUid = String(this.route.snapshot.queryParamMap.get('itemgroupuid'));

    if(itemGroupUid !== null)
      this.itemGroup = this.currentorderservice.getComboItemGroup(itemGroupUid);

    if(this.itemGroup)
    {
      var itempreset = this.itemGroup.ItemPresetList.find(x => x.ItemUniversalID === comboitemuid);

      if(itempreset)
        this.itemHolder.MenuItem.ComboPrice = itempreset.Price;
    }

    this.updateCurrentPrice();

    setTimeout(() => this.updateCanSave(), 300);

    KeyboardDetector(visibility => { this.showBottomBar = visibility === "hidden"; });
  }

  ngAfterViewInit() : void
  {
    this.setStickyTop();
  }

  setStickyTop()
  {
    var topbar = document.getElementById("topbar");

    if(topbar)
    {
      for (let index = 0; index < this.itemHolder.DetailGroupPacks.length; index++) 
      {
        const detailPack = this.itemHolder.DetailGroupPacks[index];
        
        var element = document.getElementById(detailPack.DetailGroup.ID);

        if(element)
          element.style.top = `${topbar.offsetHeight}px`;
      }
    }
  }

  back()
  {
    this.navigationservice.back();
  }

  canReturn()
  { 
    if(this.canPop === true)
      return true;

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
      return true;

    return new Promise<boolean>((resolve, reject) =>
    {
      let dialogRef = this.alertDialog.open(AlertDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Accept"), 
          cancel:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Cancel")  
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        resolve(result);
      });
    });
  }

  detailTap(detail:Detail, detailGroupPack:DetailGroupPack)
  {
    if(detailGroupPack.DetailGroup.LimitMacroSelection && detail.Type === 0 && detail.CurrentCount === 0 && this.itemHolder.isMacroMaxedOut(detailGroupPack.DetailGroup.MacroID))
    {  
      this.showMaxOptionsWarning();

      return;
    }

    if(detailGroupPack.DetailGroup.LimitSelection && detail.Type === 0 && detail.CurrentCount === 0 && detailGroupPack.isMaxedOut())
    {
      this.showMaxOptionsWarning();

      return;
    }

    if(detail.MaxCount > 1)
    {
      var max = detail.MaxCount;

      if(detailGroupPack.DetailGroup.LimitMacroSelection || detailGroupPack.DetailGroup.LimitSelection)
      {
        var remaining = detailGroupPack.getRemainingSelections(this.itemHolder.getMacroSelectionCount(detailGroupPack.DetailGroup.MacroID));

        if(max > remaining)
          max = remaining + detail.CurrentCount;
        
        if(detailGroupPack.isMaxedOut())
          max = detail.CurrentCount;
      }

      let dialogRef = this.alertDialog.open(StepperDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        {  
          title:detail.Name, 
          detail: `${this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Detail")}(Max:${max})`, 
          count:detail.CurrentCount, 
          maxcount:max,
          accept:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Accept"),
          cancel:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Cancel"),
         }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        if(result !== null && result != undefined && result !== '')
        {
          var newCount = Number(result);

          if(newCount !== null && newCount !== undefined)
          {
            var status =  detailGroupPack.detailTap(detail, newCount, this.itemHolder.getMacroSelectionCount(detailGroupPack.DetailGroup.MacroID));
            
            if(status)
            {
              this.updateLimitSelectionDescription(detailGroupPack);

              this.updateCurrentPrice();

              this.updateCanSave();

              setTimeout(() => this.goToNextDetailGroup(detailGroupPack), 175);
            }
          }
        }
      });
    }
    else
    {
      var status = detailGroupPack.detailTap(detail);

      if(status)
      {
        this.updateLimitSelectionDescription(detailGroupPack);

        this.updateCurrentPrice();

        this.updateCanSave();

        setTimeout(() => this.goToNextDetailGroup(detailGroupPack), 175);
      }
    }
  }

  showMaxOptionsWarning()
  {
    this.alertDialog.open(AlertDialogComponent, 
    {
      height: 'fit-content',
      width: 'fit-content',
      data: 
      { 
        title: this.localeservice.instantTranslation("Dialogs.Alert.MaxOptionCount.Title"),
        detail:this.localeservice.instantTranslation("Dialogs.Alert.MaxOptionCount.Detail"), 
        accept:this.localeservice.instantTranslation("Dialogs.Alert.MaxOptionCount.Accept") 
      }
    });
  }

  updateLimitSelectionDescription(detailGroupPack:DetailGroupPack)
  {
    var macroPacks = this.itemHolder.getMacroPacks(detailGroupPack.DetailGroup.MacroID);

    if(macroPacks.length > 0)
    {
      var macroCount = 0;

      for (let index = 0; index < macroPacks.length; index++) 
      {
          const element = macroPacks[index];
          
          macroCount += element.getSelectionCount();
      }

      for (let index = 0; index < macroPacks.length; index++) 
      {
        const element = macroPacks[index];
        
        element.updateLimitSelectionDescription(macroCount, element.DetailGroup.MacroMinSelectionCount);
      }
    }
    else
      detailGroupPack.updateLimitSelectionDescription();
  }

  showList(detailGroupPack:DetailGroupPack, show:boolean)
  {
    if(show === true)
    {
      this.itemHolder.DetailGroupPacks.forEach(x => x.ShowList = x.DetailGroup.ID === detailGroupPack.DetailGroup.ID);

      setTimeout(() =>
      {
        var element = document.getElementById(detailGroupPack.DetailGroup.ID);

        if(element)
          this.scrollTo(element);
      }, 150);
    }
    else
      detailGroupPack.ShowList = false;
  }

  goToNextDetailGroup(currentDetailGroup:DetailGroupPack)
  {
    if(!this.jumpedGroups.find(x => x === currentDetailGroup.DetailGroup.ID) && (currentDetailGroup.isMaxedOut() && !currentDetailGroup.HasDefault() || (currentDetailGroup.DetailGroup.LimitMacroSelection && this.itemHolder.isMacroMaxedOut(currentDetailGroup.DetailGroup.MacroID))))
    {
      var currentGroupIndx = this.itemHolder.DetailGroupPacks.findIndex(x => x.DetailGroup.ID == currentDetailGroup.DetailGroup.ID);

      if(currentGroupIndx > -1 && this.itemHolder.DetailGroupPacks.length -1 > currentGroupIndx)
      {
        var nextGroupPack = this.itemHolder.DetailGroupPacks[currentGroupIndx + 1];

        if(nextGroupPack.isMaxedOut() && !nextGroupPack.HasDefault() || (nextGroupPack.DetailGroup.LimitMacroSelection && this.itemHolder.isMacroMaxedOut(nextGroupPack.DetailGroup.MacroID)))
        {
          this.goToNextDetailGroup(nextGroupPack);

          return;
        }
        
        this.showList(nextGroupPack, true);

        this.jumpedGroups.push(currentDetailGroup.DetailGroup.ID);
      }
      else if(this.lastRippleDone === false)
      {
        this.lastRippleDone = true;

        if(this.itemHolder.DetailGroupPacks.length > 0)
          this.fireBottomRipple();
      }
    }
  }

  scrollTo(element:HTMLElement)
  {
    var topbar = document.getElementById("topbar");

    if(topbar)
    {
      var bounds = element.getBoundingClientRect();

      window.scrollTo(
        {
          top: bounds.top + window.scrollY - topbar.offsetHeight,
          behavior: "smooth"
        });
    }
  }

  updateCurrentPrice()
  {
    var currentComboPrice = this.itemHolder.CurrentComboPrice * this.currentorderservice.getCurrentComboCount();

    if(this.itemGroup.CurrentItem.length === 0)
      currentComboPrice = this.currentorderservice.getCurrentComboPrice() + currentComboPrice - this.initialAdditionalPrice;
    else
    {
      var otheritem = this.currentorderservice.getComboItem(this.itemGroup.CurrentItem);

      if(otheritem.ID.length > 0)
        currentComboPrice = this.currentorderservice.getCurrentComboPrice() + (currentComboPrice - this.initialAdditionalPrice) - (otheritem.CurrentComboPrice * this.currentorderservice.getCurrentComboCount());
    }  

    this.currentPriceString = this.localeservice.getCurrencyString(currentComboPrice);
  }

  updateCanSave()
  {
    var before = this.canSave;

    this.canSave = this.itemHolder.getValidation() === true && this.itemHolder.checkMacro() === true;

    if(before != this.canSave && this.canSave === true)
      this.fireBottomRipple();
  }

  save()
  {
    if(this.canSave === true)
    {
      if(this.status === 'edit')
      {
        var result = this.currentorderservice.saveComboItem(this.itemHolder);

        if(result === true)
        {
          this.canPop = true;

          this.back();
        }
        else
        {
          this.alertDialog.open(AlertDialogComponent, 
          {
            height: 'fit-content',
            width: 'fit-content',
            data: { title:'Aviso', detail:'Não foi possível salvar o item do combo.', accept:'Entendi' }
          });
        }

        return;
      }

      if(this.itemGroup)
      {
        if(this.status === 'new')
        {
          var result = this.currentorderservice.addComboItem(this.itemHolder, this.itemGroup);

          if(result === true)
          {
            this.canPop = true;

            this.back();
          }
          else
          {
            this.alertDialog.open(AlertDialogComponent, 
            {
              height: 'fit-content',
              width: 'fit-content',
              data: { title:'Aviso', detail:'Não foi possível adicionar o item ao combo.', accept:'Entendi' }
            });
          }
        }

        if(this.status === 'change')
        {
          var result = this.currentorderservice.changeComboItem(this.itemHolder, this.itemGroup.CurrentItem, this.itemGroup);

          if(result === true)
          {
            this.canPop = true;

            this.back();
          }
          else
          {
            this.alertDialog.open(AlertDialogComponent, 
              {
                height: 'fit-content',
                width: 'fit-content',
                data: 
                { 
                  title: this.localeservice.instantTranslation("Dialogs.Alert.ItemChangeError.Title"),
                  detail:this.localeservice.instantTranslation("Dialogs.Alert.ItemChangeError.Detail"), 
                  accept:this.localeservice.instantTranslation("Dialogs.Alert.ItemChangeError.Accept") 
                }
              });
          }
        }
      }
      else
      {
        this.alertDialog.open(AlertDialogComponent, 
        {
          height: 'fit-content',
          width: 'fit-content',
          data: 
          { 
            title: this.localeservice.instantTranslation("Dialogs.Alert.ItemSaveError.Title"),
            detail:this.localeservice.instantTranslation("Dialogs.Alert.ItemSaveError.Detail"), 
            accept:this.localeservice.instantTranslation("Dialogs.Alert.ItemSaveError.Accept") 
          }
        });
      }
    }
  }

  fireBottomRipple()
  {
    if(this.ripple)
    {
      const rippleRef = this.ripple.launch({ persistent: true, centered:true });
      
      setTimeout(() => rippleRef.fadeOut(), 1000);
    }
  }
}
